import colour from "./colour";
import gradient from "./gradient";
import image from "./image";
import unsplash from "./unsplash";

export const backgroundConfigs = [unsplash, colour, gradient, image];
